import React, { useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs';
import AddIcon from '@mui/icons-material/Add';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import CommonPagination from '../Common/CommonPagination';
import Assets from '../Common/Assets';
import StatusButton from '../Common/StatusButton';
import IconBackground from '../Common/IconBackground';
import AddNewVendor from './AddNewVendor';
import { useDispatch } from 'react-redux';
import ViewVendorData from './ViewVendorData';
import CustomDrawer from '../Common/CustomDrawer';
import ErrorHandler from '../../lib/errorHandler';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import FilterListIcon from '@mui/icons-material/FilterList';
import { downloadVendor, getVendorById, getVendors } from '../../Redux/Actions/Vendor';
import { businessTypeOption, categoryNameOptions, rawMaterialOption, Title, useCommonStyles } from '../../utils';
import { Badge, Box, Button, Checkbox, Chip, FormControl, FormControlLabel, FormGroup, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import { useAppSelector } from '../../Redux/app/hooks';
import CommonSearchField from '../Common/CommonSearchField';
import CommonMenuItems from '../Common/CommonMenuItems';
import { standardDateFormat } from '../../lib/standardDateFormat';
import localStoreUtil from '../../ApiSetUp/localstore.util';
import { BaseUrl, LOGIN_TOKEN } from '../../ApiSetUp/AuthApi';
import axios from 'axios';
import CustomTooltip from '../Common/CustomTooltip';

const VendorManagement = () => {
    // =============== Hooks ===============
    const sigCanvas = useRef(null);
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== Constants ===============
    const getInitialVendor = () => ({
        vendorType: ["Local"],
        isGrade: "no",
        gradeD: "nonCritical",
    });
    // =============== States ===============
    const [page, setPage] = useState(1);
    const [vendor, setVendor] = useState(getInitialVendor());
    const [isOpenAddVendor, setIsOpenAddVendor] = useState(false);
    const [isViewVendor, setIsViewVendor] = useState(false);
    const [vendorData, setVendorData] = useState({});
    const [selectedVendorData, setSelectedVendorData] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);

    const initialFilterState = {
        rawMaterial: [],
        approval: "",
        isblackListed: ""
    };

    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);

    // =============== Handler ===============
    const tabelHeader = ["SR.", "Vendor Code", "Vendor Name", "Document", 'Item Name ANd Service Name', "type Of vendor", "Vendor Approval Date", "Blacklist Date", "Approval", "Action"]
    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

    let PerPage = 10

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    const filterDataCount = (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial?.length : 0) + (filterData?.approval?.trim() ? 1 : 0)
    // ============= get Vendors API =============
    const _getVendors = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "rawMaterial": isApllyFilter ? (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial : null) : null,
            "approval": isApllyFilter ? (filterData?.approval?.trim() ? (filterData?.approval == "Yes" ? true : filterData?.approval == "No" ? false : null) : null) : null,
            "isBlackListed": isApllyFilter ? (filterData?.isblackListed?.trim() ? (filterData?.isblackListed == "Yes" ? true : filterData?.isblackListed == "No" ? false : null) : null) : null,
        }
        response = await dispatch(getVendors(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setVendorData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= get Vendors API =============
    const _getVendorById = async (id, isEdit) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getVendorById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setSelectedVendorData(response?.payload?.data?.response)
                let res = response?.payload?.data?.response
                const setBussinessTypeOption = res?.bussiness_type?.map((ele) => {
                    return {
                        id: ele,
                        name: businessTypeOption?.find((item) => item?.id === ele)?.name
                    }
                })
                const setRowMaterialOptions = res?.rawMaterial?.map((ele) => {
                    return {
                        name: ele,
                        id: categoryNameOptions?.find((item) => item?.name === ele)?.id,
                    }
                })
                if (isEdit) {
                    setIsOpenAddVendor(true)
                    const base64Signature = res?.approvalDetails?.signature;
                    const dataURL = base64Signature ? `data:image/png;base64,${base64Signature}` : "";
                    setVendor({
                        ...vendor,
                        "vendorType": res?.vendorType || ["Local"],
                        "name": res?.name,
                        "vendorId": res?.vendorCode,
                        "mobileNumber": res?.mobileNumber,
                        "companyName": res?.personName,
                        "rawMaterial": setRowMaterialOptions,
                        "address": res?.address,
                        "getType": res.isGstNo ? "1" : "2",
                        "gstNumber": res?.gstNumber,
                        "firstDoc": res?.GSTDocument ? String(res?.GSTDocument) : null,
                        "secondDoc": res?.MSMEDocument ? String(res?.MSMEDocument) : null,
                        "bussiness_type": setBussinessTypeOption,
                        "isGrade": res?.gradeD?.isYes,
                        "gradeD": res?.gradeD?.isCritical,
                        "selectionCriteria": String(res?.selectionCriteria),
                        "receivedDate": res.receivedDate ? dayjs(res.receivedDate).format("YYYY-MM-DD") : null,
                        "approvedDate": res.approvedDate ? dayjs(res.approvedDate).format("YYYY-MM-DD") : null,
                        "description": res?.description,
                        "approvalName": res?.approvalDetails?.approvalName,
                        "approvalDate": res?.approvalDetails?.approvalDate ? dayjs(res?.approvalDetails?.approvalDate).format("YYYY-MM-DD") : null,
                        "annexure": res?.approvalDetails?.annexure == true ? "true" : res?.approvalDetails?.annexure == false ? 'false' : null,
                        "signature": res?.approvalDetails?.signature,
                        "otherName": res?.otherName,
                        "checkbox_1": res?.approvalDetails?.checkbox_1 == true ? "true" : res?.approvalDetails?.checkbox_1 == false ? "false" : null,
                        "checkbox_2": res?.approvalDetails?.checkbox_2 == true ? "true" : res?.approvalDetails?.checkbox_2 == false ? "false" : null,
                        "checkbox_3": res?.approvalDetails?.checkbox_3 == true ? "true" : res?.approvalDetails?.checkbox_3 == false ? "false" : null,
                        "checkbox_4": res?.approvalDetails?.checkbox_4 == true ? "true" : res?.approvalDetails?.checkbox_4 == false ? "false" : null,
                        "checkbox_5": res?.approvalDetails?.checkbox_5 == true ? "true" : res?.approvalDetails?.checkbox_5 == false ? "false" : null,
                        "checkbox_6": res?.approvalDetails?.checkbox_6 == true ? "true" : res?.approvalDetails?.checkbox_6 == false ? "false" : null,
                        "checkbox_7": res?.approvalDetails?.checkbox_7 == true ? "true" : res?.approvalDetails?.checkbox_7 == false ? "false" : null,
                        "checkbox_8": res?.approvalDetails?.checkbox_8 == true ? "true" : res?.approvalDetails?.checkbox_8 == false ? "false" : null,
                        "isBlackListed": res?.isBlackListed ? true : false,
                        "blackListDate": res.blackListDate ? dayjs(res.blackListDate).format("YYYY-MM-DD") : null,
                        "remark": res?.remark,
                    })
                    setTimeout(() => {
                        if (sigCanvas.current && dataURL) {
                            sigCanvas.current.fromDataURL(dataURL);
                        }
                    }, 100);
                } else {
                    setIsViewVendor(true)
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= download Grn API =============
    const _downloadVendor = async (row) => {
        setFullPageLoader(true);
        let response;
        let body = {
            id: row?._id
        }
        response = await dispatch(downloadVendor(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data
                _downloadPO(`data:text/html;base64,${res?.blob}`, `${row?.name}_Vendor_Form.html`)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= download All Vendor API =============
    const _downloadAllVendor = async () => {
        try {
            setFullPageLoader(true);
            let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
            const response = await axios.post(
                `${BaseUrl}admin/downloadVendorSheet`,
                {
                    "search": searchValue,
                    "rawMaterial": isApllyFilter ? (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial : null) : null,
                    "approval": isApllyFilter ? (filterData?.approval?.trim() ? (filterData?.approval == "Yes" ? true : filterData?.approval == "No" ? false : null) : null) : null,
                    "isBlackListed": isApllyFilter ? (filterData?.isblackListed?.trim() ? (filterData?.isblackListed == "Yes" ? true : filterData?.isblackListed == "No" ? false : null) : null) : null,
                },
                {
                    responseType: "blob",  // Ensure response is received as a file
                    headers: {
                        Authorization: `Bearer ${login_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.data || response.data.size === 0) {
                console.error("Empty file received, check API response");
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Vendor_List.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error fetching yearly totals:", error);
        } finally {
            setFullPageLoader(false);
        }
    };

    const _downloadPO = (base64Data, fileName = "document.pdf") => {
        const base64String = base64Data.split(",")[1];

        // Convert Base64 to binary data
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob with MIME type application/pdf
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // Generate Blob URL
        const blobURL = URL.createObjectURL(blob);

        // Create a hidden download link
        const a = document.createElement("a");
        a.href = blobURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoke the Blob URL to free memory
        URL.revokeObjectURL(blobURL);
    };


    useEffect(() => {
        if (searchValue) {
            _getVendors();
        } else {
            _getVendors();
        }
    }, [page, searchValue])

    useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        setPage(1)
        _getVendors(1);
    }, [isApllyFilter])



    return (
        isOpenAddVendor ?
            <AddNewVendor setSearchValue={setSearchValue} setIsOpenAddVendor={setIsOpenAddVendor} selectedVendorData={selectedVendorData} setSelectedVendorData={setSelectedVendorData} _getVendors={_getVendors} vendor={vendor} setVendor={setVendor} getInitialVendor={getInitialVendor} sigCanvas={sigCanvas} />
            :
            <Grid container spacing={3}>
                <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={"wrap"}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Vendors List</Typography>
                    <Box display={"flex"} alignItems={'center'} gap={2} flexWrap={'wrap'}>
                        <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Vendor Code", "Vendor Name", "Phone Number", "Person Name"]} />
                        <CustomTooltip
                            title={"Download vendor list"}>
                            <Box>
                                <IconBackground icon={"download"} onClick={() => _downloadAllVendor()} />
                            </Box>
                        </CustomTooltip>
                        <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                            <Button className={classes.cancelButton} onClick={() => setIsOpenFilterDrawer(true)} startIcon={<FilterListIcon />}>Filters </Button>
                        </Badge>
                        {getPermissionList?.editPermission?.includes('Vendor Management') &&
                            <Button className={classes.saveButton} onClick={() => setIsOpenAddVendor(true)} startIcon={<AddIcon />}>Add New Vendor </Button>
                        }
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                        <TableContainer>
                            <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                <TableHead>
                                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                        {tabelHeader?.map((ele) => {
                                            return (
                                                <StyledTableCell >{ele}</StyledTableCell>
                                            )
                                        })}
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {vendorData?.response?.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <StyledTableRow>
                                                <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                <StyledTableCell> {row.vendorCode ? row.vendorCode : "NA"}</StyledTableCell>
                                                <StyledTableCell> {row.name}</StyledTableCell>
                                                <StyledTableCell>
                                                    <Box display={"flex"} gap={2}>
                                                        {row.GSTDocument &&
                                                            <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                <Assets absolutePath={true} src={`/assets/img/Msme.svg`} />
                                                                GST Certificate
                                                            </Box>
                                                        }
                                                        {row.MSMEDocument &&
                                                            <Box display={"flex"} gap={1} alignItems={"center"}>
                                                                <Assets absolutePath={true} src={`/assets/img/Msme.svg`} />
                                                                MSME Certificate
                                                            </Box>
                                                        }
                                                    </Box>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Box display={'flex'} gap={1}>
                                                        {row.rawMaterial?.map((item) => {
                                                            return (
                                                                <Chip
                                                                    variant="outlined"
                                                                    sx={{
                                                                        fontSize: "12px",
                                                                    }}
                                                                    label={item == "Other" ? row?.otherName : item}
                                                                />)
                                                        })}
                                                    </Box>
                                                </StyledTableCell>
                                                <StyledTableCell> {row?.gradeD?.isCritical}</StyledTableCell>
                                                <StyledTableCell> {row?.approvalDetails?.approvalDate && standardDateFormat(row?.approvalDetails?.approvalDate)}</StyledTableCell>
                                                <StyledTableCell> {row?.blackListDate && standardDateFormat(row?.blackListDate)}</StyledTableCell>
                                                <StyledTableCell>
                                                    <StatusButton text={row.approval ? "Yes" : "No"} color={row.approval ? "success" : "gray"} />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Box display={"flex"} gap={1}>
                                                        {getPermissionList?.viewPermission?.includes('Vendor Management') &&
                                                            <IconBackground icon={"visibility"} onClick={() => _getVendorById(row?._id, false)} />
                                                        }
                                                        {getPermissionList?.editPermission?.includes('Vendor Management') &&
                                                            <IconBackground icon={"edit"} onClick={() => _getVendorById(row?._id, true)} />
                                                        }
                                                        <IconBackground icon={"download"} onClick={() => _downloadVendor(row)} />
                                                    </Box>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <CommonPagination
                            totalCount={vendorData?.count}
                            count={Math.ceil(vendorData?.count / PerPage)}
                            itemsPerPage={PerPage}
                            page={page}
                            onChange={handleChangePage}
                        />
                    </Box>
                </Grid>
                <CustomDrawer
                    isDrawerOpen={isViewVendor}
                    handleClose={() => { setIsViewVendor(false); setSelectedVendorData({}) }}
                    title="Vendor Registration form"
                >
                    <ViewVendorData setIsViewVendor={setIsViewVendor} selectedVendorData={selectedVendorData} />
                </CustomDrawer>
                <CustomDrawer
                    isOnlyIconClose
                    isDrawerOpen={isOpenFilterDrawer}
                    handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}
                    title="Filter"
                >
                    <Grid container p={2}>
                        <Grid item xs={12}>
                            <Title>Category</Title>
                        </Grid>
                        {["Base Paper", "Film", "Chemical", "Ink", "Packaging Material", "Other"].map((ele) => {
                            const isChecked = filterData.rawMaterial.includes(ele);
                            return (
                                <Grid item xs={12} sm={6} md={4} key={ele}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isChecked}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => ({
                                                                ...prev,
                                                                rawMaterial: e.target.checked
                                                                    ? [...prev.rawMaterial, ele]
                                                                    : prev.rawMaterial.filter((item) => item !== ele)
                                                            }));
                                                        }}
                                                    />
                                                }
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            );
                        })}
                        <Grid item xs={12}>
                            <Title>Approval</Title>
                        </Grid>
                        {["Yes", "No"].map((ele) => {
                            const isChecked = filterData.approval === ele;
                            return (
                                <Grid item xs={12} sm={6} md={4} key={ele}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox checked={filterData.approval === ele}
                                                    onChange={() => { setFilterData((prev) => ({ ...prev, approval: isChecked ? "" : ele })) }} />}
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            );
                        })}
                        <Grid item xs={12}>
                            <Title>Blacklisted</Title>
                        </Grid>
                        {["Yes", "No"].map((ele) => {
                            const isChecked = filterData.isblackListed === ele;
                            return (
                                <Grid item xs={12} sm={6} md={4} key={ele}>
                                    <FormControl component="fieldset">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox checked={filterData.isblackListed === ele}
                                                    onChange={() => { setFilterData((prev) => ({ ...prev, isblackListed: isChecked ? "" : ele })) }} />}
                                                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                label={ele}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                            );
                        })}
                        <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                            <Button className={classes.cancelButton}
                                onClick={() => {
                                    setFilterData(initialFilterState);
                                    // setIsOpenFilterDrawer(false);
                                    // setIsApplyFilter(isApllyFilter + 1)
                                }}>
                                Reset Filter
                            </Button>
                            <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                                Apply Filter
                            </Button>
                        </Grid>
                    </Grid>
                </CustomDrawer>
            </Grid >

    )
}

export default VendorManagement